export default __webpack_public_path__ + "static/media/amenity-2.f6f7ddeb.jpg";